import { render } from "./ComponentNewHostFree.vue?vue&type=template&id=6318f36a"
import script from "./ComponentNewHostFree.vue?vue&type=script&lang=js"
export * from "./ComponentNewHostFree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__